var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.656V5.344C3 4.326 3.826 3.5 4.844 3.5H19.156C20.174 3.5 21 4.326 21 5.344V18.656C21 19.674 20.174 20.5 19.156 20.5H4.844C3.826 20.5 3 19.674 3 18.656Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M13.8109 7.36807C15.5682 9.12543 15.5682 11.9747 13.8109 13.732C12.0535 15.4894 9.20429 15.4894 7.44693 13.732C5.68957 11.9747 5.68957 9.12543 7.44693 7.36807C9.20429 5.61071 12.0535 5.61071 13.8109 7.36807",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10.8912 10.2877C11.0361 10.4326 11.0361 10.6675 10.8912 10.8124C10.7464 10.9573 10.5115 10.9573 10.3666 10.8124C10.2217 10.6675 10.2217 10.4326 10.3666 10.2877C10.5115 10.1428 10.7464 10.1428 10.8912 10.2877",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M16 17.05V17.05C17.105 17.05 18 16.155 18 15.05V15.05V6.05005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M6 17.55H7",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjSet);
export default __webpack_public_path__ + "static/media/dj-set.9f7306c6ecb3e3a625c7c2f14c2d538e.svg";
export { ForwardRef as ReactComponent };